import { SxProps } from '@mui/material';

import type { Theme } from '../../themes/themes';
import { ProductLinkProps } from './ProductLink';

export const getStyles = (theme: Theme, { disabled }: Partial<ProductLinkProps>): { [key: string]: SxProps<Theme> } => {
  return {
    container: {
      cursor: disabled ? 'unset' : 'pointer',
      lineHeight: 1,

      '&:focus-visible': {
        boxShadow: `inset 0px 0px 0px 5px ${theme.palette.primary.dark}`,
        outline: '3px solid white',
        outlineOffset: '-3px',
      },

      'button&': {
        backgroundColor: 'transparent',
        border: 'none',
        padding: 0,
        width: '100%',
      },

      '&, .if6 &': {
        textDecoration: 'none',
        pointerEvents: 'auto',
      },
    },
    startIcon: {
      color: disabled ? theme.palette.grey['500'] : theme.palette.text.primary,
      verticalAlign: 'text-top',

      fontSize: theme.spacing(5),
      [theme.breakpoints.up('lg')]: {
        fontSize: theme.spacing(6),
      },
    },
    endIcon: {
      color: disabled ? theme.palette.grey['500'] : theme.palette.text.primary,
      verticalAlign: 'text-top',

      fontSize: theme.spacing(5),
      [theme.breakpoints.up('lg')]: {
        fontSize: theme.spacing(6),
      },

      marginLeft: 'auto',
    },
    textWrap: {
      alignSelf: 'center',
      color: disabled ? theme.palette.grey['500'] : theme.palette.text.primary,
    },
    textEllipsis: {
      alignSelf: 'center',
      color: disabled ? theme.palette.grey['500'] : theme.palette.text.primary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    description: {
      color: disabled ? theme.palette.grey['500'] : theme.palette.action.active,
      textDecoration: 'none',
    },
  };
};
